import {videoUrl} from "./video-js";

export function checkIsLive(settings, callback, schedule) {
    return checkLiveState(settings, true, callback, schedule)
}

export function checkIsOffLine(settings, callback, schedule) {
    return checkLiveState(settings, false, callback, schedule)
}

async function isLive(settings) {
    try {
        const res = await fetch(`${videoUrl(settings)}/index.m3u8`)
        return res.status === 304 || res.status === 200
    }
    catch {
        return false
    }
}

/**
 * Will callback as soon as the service is online or offline
 * @param settings
 * @param state When true, will callback when online, when false will callback when offline
 * @param callback
 * @param schedule to retry on, see retrySchema for format - defaults to every 10 seconds
 */
function checkLiveState(settings, state, callback, schedule = [{ seconds: 10, times: Infinity }]) {
    const secondsToWait = retryScheduler(schedule)

    let timeout = null

    async function check() {
        if ((await isLive(settings)) === state) {
            callback()
            return
        }
        timeout = setTimeout(check, secondsToWait() * 1000)
    }

    check().catch(console.error);

    return () => clearTimeout(timeout)
}


function retryScheduler(schema) {
    let copy = schema.map((s) => ({...s}))

    let currentIndex = 0
    let currentTry = 0

    return function next() {
        const secondsToWait = copy[currentIndex].seconds
        if (currentTry === copy[currentIndex].times - 1) {
            currentIndex++
            currentTry = 0
        }
        else {
            currentTry++
        }
        return secondsToWait
    }
}
